import React from 'react';
import {NavLink} from 'react-router-dom';

const TopMenu = ({nav}) => (
  <nav>
    {nav.map(item => (
      <NavLink key={item.url} to={item.url}>
        {item.title}
      </NavLink>
    ))}
  </nav>
);

export default TopMenu;
